var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketFriendlyName = function SvgTicketFriendlyName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5476_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C27.2091 0 29 1.79086 29 4V31C29 31.3688 28.7968 31.7078 28.4717 31.8818C28.1466 32.0557 27.7521 32.0366 27.4453 31.832L24.9277 30.1543L21.4473 31.8945C21.1657 32.0353 20.8343 32.0353 20.5527 31.8945L17 30.1182L13.4473 31.8945C13.1657 32.0353 12.8343 32.0353 12.5527 31.8945L9.07227 30.1543L6.55469 31.832C6.2479 32.0366 5.85344 32.0557 5.52832 31.8818C5.20317 31.7078 5 31.3688 5 31V11H1C0.447718 11 5.15404e-06 10.5523 0 10V3.5C0 1.567 1.567 0 3.5 0H17V22L21 20L25 22V0ZM3.5 2C2.67157 2 2 2.67157 2 3.5V9H5V3.5C5 2.67157 4.32843 2 3.5 2Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5476_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor"
  })))));
};
export default SvgTicketFriendlyName;